module.exports = __webpack_public_path__ + "img/1137194.jpg";